import * as React from 'react'
import { TagDropdownConnected } from './TagDropdownConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TASK_A_ID } from 'mockState'

export const TagDropdownExamples = () => {
  return (
    <div className="TagDropdownExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TagDropdownConnected taskId={MOCK_TASK_A_ID} />
      </Provider>
    </div>
  )
}
